import { render } from "./Main.vue?vue&type=template&id=a319eb7c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=a319eb7c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a319eb7c"

export default script